// Single-tenant pragmatism: today there is exactly one parish (Our
// Lady of Grace). Used only where a parish slug is needed but
// neither the current URL nor an active session supplies one — the
// unscoped admin entry points (/, /sign-in) predate the parish-scoped
// volunteer routes and have no slug of their own.
//
// If/when a second parish is onboarded, every use of this constant is
// the actual multi-tenant gap to close — grep for it rather than
// re-deriving where the assumption lives.
export const DEFAULT_PARISH_SLUG = "our-lady-of-grace";
